import {themeSpacing} from '../constants';

const MuiMenuItem = {
    styleOverrides: {

        root: {
            paddingBottom: themeSpacing[2] + "px",
            paddingTop: themeSpacing[2] + "px",
            fontWeight: 500,
        }
    }
}

export default MuiMenuItem;